import { FILE_TYPES, FileTypes } from "../../interfaces/enums/file-types-enum";

export const downloadBase64Files = ( base64: string, fileName: string, type?: FileTypes ) => {
    // Convertir base64 a blob
    const byteCharacters = atob( base64 );
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: type || FILE_TYPES.PDF });

    // Crear URL del blob
    const url = URL.createObjectURL(blob);

    // Crear enlace <a> y simular clic para descargar
    const enlaceDescarga = document.createElement('a');
    enlaceDescarga.href = url;
    enlaceDescarga.download = fileName;
    document.body.appendChild(enlaceDescarga);
    enlaceDescarga.click();

    // Limpiar después de la descarga
    URL.revokeObjectURL(url);
    document.body.removeChild(enlaceDescarga);
}

export const downloadPresignedFile = async (presignedUrl: string, fileName: string, type?: string) => {
    const response = await fetch(presignedUrl);
    if (!response.ok) {
        throw new Error('Error downloading file');
    }
    const blob = await response.blob();
    // Crear URL temporal
    const url = window.URL.createObjectURL(
        new Blob([blob], {
            type: type || blob.type,
        })
    );
    // Forzar descarga
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    // Cleanup
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
};